import { useRef } from 'react';

import Card from '../ui/Card';
import classes from './NewNoteForm.module.css';

function NewNoteForm(props) {
    const titleInputRef = useRef();
    const imageInputRef = useRef();
    const dtInputRef = useRef();
    const detailInputRef = useRef();

    function submitHandler(event) {
        event.preventDefault();
        const enteredTitle = titleInputRef.current.value;
        const enteredImage = imageInputRef.current.value;
        const enteredDt = dtInputRef.current.value;
        const enteredDetail = detailInputRef.current.value;

        const noteData = {
            title: enteredTitle,
            image: enteredImage,
            dt: enteredDt,
            detail: enteredDetail
        };
        
        props.onAddNote(noteData);
    }

    const now = new Date()
    return (
        <Card>
        <form className={classes.form} onSubmit={submitHandler}>
            <div className={classes.control}>
            <label htmlFor='title'>Note Title</label>
            <input type="text" required id="title" ref={titleInputRef} />
            </div>
            <div className={classes.control}>
            <label htmlFor='image'>Note Image</label>
            <input type="url" required id="image" ref={imageInputRef} />
            </div>
            <div className={classes.control}>
            <label htmlFor='address'>Date</label>
            <input type="text" required id="address" ref={dtInputRef} defaultValue={now} />
            </div>
            <div className={classes.control}>
            <label htmlFor='description'>Detail</label>
            <textarea id='description' required rows='5' ref={detailInputRef}></textarea>
            </div>
            <div className={classes.actions}>
            <button>Add Note</button>
            </div>
        </form>    
        </Card>
    );
}

export default NewNoteForm;
